export default __webpack_public_path__ + "static/media/CHT_A02_QSG_20190409.efb00da7.pdf";